// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"cc9f276a","353":"180529a8","586":"74b79611","599":"96baecc2","641":"858e9acc"}[chunkId] + ".chunk.js";
};